import { HistoryMergerBasedByMin } from './HistoryMergerBasedByMin';
import { Interval } from '@shared/utils/History/Interval';
export class HistoryMergerIntradayByDayStart extends HistoryMergerBasedByMin {
    constructor(inputParams) {
        super(inputParams);
    }
    GetStartPoint(date) {
        const sessionOffset = this.session.TimeOffset;
        // аггрегация от начала дня, минус оффсет сессии
        const sessionStart = this.session.ConvertDateToSessionDateTime(date).startOf('day');
        const startSessionDate = sessionStart.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        const sessionStartDateWithOffcet = startSessionDate.plus({ minutes: sessionOffset });
        const maxEnd = sessionStartDateWithOffcet.plus({ hours: 24 }); // интрадей агрегация не должна попадать в следующий день
        const interval = new Interval();
        interval.From = sessionStartDateWithOffcet.toJSDate();
        interval.To = maxEnd.toJSDate();
        return interval;
    }
}
